import { render, staticRenderFns } from "./GoodsManage.vue?vue&type=template&id=e2a2f528&scoped=true&"
import script from "./GoodsManage.vue?vue&type=script&lang=js&"
export * from "./GoodsManage.vue?vue&type=script&lang=js&"
import style0 from "./GoodsManage.vue?vue&type=style&index=0&id=e2a2f528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a2f528",
  null
  
)

export default component.exports